// import React, { useState, useEffect, useRef } from 'react';
// import { Modal, Button, Form } from 'react-bootstrap';
// import JoditEditor from 'jodit-react';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import './routespages.css';
// import { Base_Url } from '../config';
// import { useParams } from 'react-router-dom';
// import axios from 'axios';

// function RoutesPage() {
//   const [pages, setPages] = useState([]);
//   const [showAddModal, setShowAddModal] = useState(false);
//   const [showEditModal, setShowEditModal] = useState(false);
//   const [currentPage, setCurrentPage] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);
//   const { id } = useParams();

//   const [formData, setFormData] = useState({
//     parent_routes: '',
//     route_id: id ? parseInt(id, 10) : null,
//     author: '',
//     content: '',
//     title: ''
//   });

//   const editor = useRef(null);

//   const editorConfig = {
//     readonly: false,
//     height: "90vh",
//     minHeight: 1000,
//     maxHeight: 3000,
//     editHTMLDocumentMode: true,
//     enableDragAndDropFileToEditor: true,
//     askBeforePasteHTML: false,
//     askBeforePasteFromWord: false,
//     defaultActionOnPaste: 'insert_clear_html',
//     beautifyHTML: false,
//     useSearch: true,
//     spellcheck: true,
//     enterMode: 'br',
//     toolbarSticky: true,
//     showXPathInStatusbar: false,
//     buttons: [
//         'source', '|',
//         'bold', 'italic', 'underline', 'strikethrough', '|',
//         'font', 'fontsize', 'brush', 'paragraph', '|',
//         'table', 'link', '|',
//         'left', 'center', 'right', 'justify', '|',
//         'undo', 'redo', '|',
//         'hr', 'eraser', 'fullsize', '|',
//         'paste', 'copyformat'
//     ],
//     uploader: {
//         url: `${Base_Url}/upload-image`,
//         filesVariableName: () => "image",
//         withCredentials: false,
//         format: "json",
//         method: "POST",
//         prepareData: (formData) => {
//             const file = formData.get("image");
//             formData.set("image", file);
//             return formData;
//         },
//         isSuccess: (resp) => {
//             if (resp.imageUrl) {
//                 const newContent = `${formData.content}<img src="${resp.imageUrl}" alt="Uploaded image" />`;
//                 setFormData(prev => ({
//                     ...prev,
//                     content: newContent
//                 }));
//                 return true;
//             }
//             return false;
//         },
//         getMessage: (resp) => resp.msgs ? resp.msgs.join("\n") : 'An error occurred',
//         process: (resp) => resp,
//     },
//     cleanHTML: {
//         fillEmptyParagraph: false,
//         removeEmptyElements: false,
//         removeSpans: false,
//         replaceNBSP: false,
//         cleanOnPaste: true,
//         removeStyles: false,
//         removeAttributes: false
//     },
//     pastePlain: false,
//     pasteFromWordTest: false,
//     pasteDataImages: true,
//     processPastedHTML: false,
//     pasteHTMLAttributes: ['*'],
//     removeAttribute: [],
//     disablePlugins: ['paste']
//   };

//   // Fetch all pages
//   const fetchPages = async () => {
//     try {
//       setLoading(true);
//       setError(null);
//       const response = await axios.get(`${Base_Url}/pages`);
//       setPages(Array.isArray(response.data) ? response.data : []);
//     } catch (error) {
//       console.error('Error fetching pages:', error);
//       setError(error.message || 'Failed to fetch pages');
//       setPages([]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Fetch parent routes
//   useEffect(() => {
//     const fetchParentRoutes = async () => {
//       try {
//         if (id) {
//           const response = await axios.get(`${Base_Url}/createroutes/${id}`);

//           if (response.data && response.data.routes) {
//             setFormData(prev => ({
//               ...prev,
//               parent_routes: response.data.routes,
//               route_id: id ? parseInt(id, 10) : null
//             }));
//           }
//         }
//       } catch (err) {
//         console.error('Failed to fetch parent routes', err);
//       }
//     };

//     fetchParentRoutes();
//   }, [id]);

//   // Initial pages fetch
//   useEffect(() => {
//     fetchPages();
//   }, []);

//   // Handle form input changes
//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setFormData(prev => ({
//       ...prev,
//       [name]: value
//     }));
//   };

//   // Handle Jodit content changes
//   const handleContentChange = (newContent) => {
//     setFormData(prev => ({
//       ...prev,
//       content: newContent
//     }));
//   };

//   // Create new page
//   const handleCreate = async () => {
//     try {
//       if (!formData.title.trim()) {
//         setError('Title is required');
//         return;
//       }

//       setLoading(true);
//       setError(null);
//       const response = await axios.post(`${Base_Url}/pages`, {
//         content: formData.content,
//         route_id: id ? parseInt(id, 10) : (formData.parent_routes ? parseInt(formData.parent_routes, 10) : null),
//         parent_routes: formData.parent_routes,
//         author: formData.author,
//         title: formData.title
//       });

//       setShowAddModal(false);
//       // Reset form data
//       setFormData({
//         parent_routes: '',
//         route_id: id ? parseInt(id, 10) : null,
//         author: '',
//         content: '',
//         title: ''
//       });
//       await fetchPages();
//     } catch (error) {
//       console.error('Error creating page:', error);
//       setError(error.response?.data?.error || 'Failed to create page');
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Update page
//   const handleUpdate = async () => {
//     try {
//       if (!formData.title.trim()) {
//         setError('Title is required');
//         return;
//       }

//       setLoading(true);
//       setError(null);
//       const response = await axios.put(`${Base_Url}/pages/${currentPage.id}`, {
//         content: formData.content,
//         route_id: formData.route_id ?formData.route_id : null, 
//         parent_routes: formData.parent_routes || currentPage.parent_route,
//         author: formData.author,
//         title: formData.title
//       });

//       setShowEditModal(false);
//       // Reset form data
//       setFormData({
//         parent_routes: '',
//         route_id: id ? parseInt(id, 10) : null,
//         author: '',
//         content: '',
//         title: ''
//       });
//       setCurrentPage(null);
//       await fetchPages();
//     } catch (error) {
//       console.error('Error updating page:', error);
//       setError(error.response?.data?.error || 'Failed to update page');
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Delete page
//   const handleDelete = async (pageId) => {
//     if (window.confirm('Are you sure you want to delete this page?')) {
//       try {
//         setLoading(true);
//         setError(null);
//         await axios.delete(`${Base_Url}/pages/${pageId}`);

//         await fetchPages();
//       } catch (error) {
//         console.error('Error deleting page:', error);
//         setError(error.response?.data?.error || 'Failed to delete page');
//       } finally {
//         setLoading(false);
//       }
//     }
//   };

//   // Open edit modal and prefill data
//   const openEditModal = (page) => {
//     console.log(page)
//     setCurrentPage(page);
//     setFormData({
//       parent_routes: page.parent_route || '',
//       route_id: page.route_id ? page.route_id :  null, 
//       author: page.author || '',
//       content: page.page_details 
//         ? (typeof page.page_details === 'string' 
//           ? page.page_details 
//           : JSON.parse(page.page_details)) 
//         : '',
//       title: page.page_title || '',
//     });
//     setShowEditModal(true);
//   };

//   // Render loading state
//   if (loading) {
//     return <div className="routes-container">Loading...</div>;
//   }

//   console.log(formData)

//   // Render error state
//   if (error) {
//     return (
//       <div className="routes-container">
//         <div className="alert alert-danger" role="alert">
//           Error: {error}
//         </div>
//         <Button onClick={fetchPages}>Retry</Button>
//       </div>
//     );
//   }

//   const truncateText = (text, maxWords = 30, ellipsis = '...') => {
//     // Handle null or empty input
//     if (!text) return '';

//     // Create a temporary div to parse HTML
//     const tempDiv = document.createElement('div');
//     tempDiv.innerHTML = text;

//     // Recursive function to truncate while preserving HTML structure
//     const truncateNode = (node) => {
//         // For text nodes, count and truncate words
//         if (node.nodeType === Node.TEXT_NODE) {
//             const words = node.textContent.trim().split(/\s+/);
//             if (words.length <= maxWords) return node;

//             // Truncate to max words
//             const truncatedText = words.slice(0, maxWords).join(' ') + (words.length > maxWords ? ellipsis : '');
//             node.textContent = truncatedText;
//             return node;
//         }

//         // For element nodes, process children
//         if (node.nodeType === Node.ELEMENT_NODE) {
//             let wordCount = 0;
//             const nodesToRemove = [];

//             // Process child nodes
//             for (let child of Array.from(node.childNodes)) {
//                 // Skip if we've exceeded word count
//                 if (wordCount >= maxWords) {
//                     nodesToRemove.push(child);
//                     continue;
//                 }

//                 // Truncate child node
//                 if (child.nodeType === Node.TEXT_NODE) {
//                     const childWords = child.textContent.trim().split(/\s+/);
//                     const remainingWords = maxWords - wordCount;

//                     if (childWords.length > remainingWords) {
//                         const truncatedText = childWords.slice(0, remainingWords).join(' ') + ellipsis;
//                         child.textContent = truncatedText;
//                         wordCount = maxWords;
//                     } else {
//                         wordCount += childWords.length;
//                     }
//                 } else if (child.nodeType === Node.ELEMENT_NODE) {
//                     const childWordCount = getNodeWordCount(child);

//                     if (wordCount + childWordCount > maxWords) {
//                         // Recursively truncate if child would exceed word limit
//                         truncateNode(child);
//                         wordCount = maxWords;
//                     } else {
//                         wordCount += childWordCount;
//                     }
//                 }
//             }

//             // Remove excess nodes
//             nodesToRemove.forEach(node => node.remove());
//         }

//         return node;
//     };

//     // Helper function to count words in a node
//     const getNodeWordCount = (node) => {
//         if (node.nodeType === Node.TEXT_NODE) {
//             return node.textContent.trim().split(/\s+/).length;
//         }

//         if (node.nodeType === Node.ELEMENT_NODE) {
//             return Array.from(node.childNodes)
//                 .reduce((count, child) => count + getNodeWordCount(child), 0);
//         }

//         return 0;
//     };

//     // Truncate the content
//     truncateNode(tempDiv);

//     return tempDiv.innerHTML;
// };
//   return (
//     <div className="routes-container">
//       <h1 className="routes-header">Pages Management</h1>

//       <Button className="routes-add-button" onClick={() => setShowAddModal(true)}>
//         Add New Page
//       </Button>

//       {pages.length === 0 ? (
//         <p>No pages found</p>
//       ) : (
//         <div className="routes-grid">
//           {pages.map(page => (
//             <div key={page.id} className="routes-card">
//               <h3>{page.page_title}</h3>
//               <p className="routes-card-author">Route: {page.parent_route || ''}</p>
//               <p className="routes-card-author">Author: {page.author || 'No Author'}</p>
//               {/* <div 
//                 className="routes-card-content" 
//                 dangerouslySetInnerHTML={{ 
//                   __html: page.page_details 
//                 }} 
//               /> */}
//                 <div className="routes-card-content" dangerouslySetInnerHTML={{ __html: truncateText(page.page_details  || '') }} />
//               <div className="routes-card-actions">
//                 <button className="routes-edit-btn" onClick={() => openEditModal(page)}>
//                   Edit
//                 </button>
//                 <button className="routes-delete-btn" onClick={() => handleDelete(page.id)}>
//                   Delete
//                 </button>
//               </div>
//             </div>
//           ))}
//         </div>
//       )}

//       {/* Add Page Modal */}
//       <Modal 
//         show={showAddModal} 
//         onHide={() => setShowAddModal(false)} 
//         className="routes-modal"
//         dialogClassName="routes-modal-dialog"
//         contentClassName="routes-modal-content"
//       >
//         <Modal.Header closeButton className="routes-modal-header">
//           <Modal.Title>Add New Page</Modal.Title>
//         </Modal.Header>
//         <Modal.Body className="routes-modal-body">
//           <Form className="routes-form">
//             <Form.Group className="mb-3">
//               <Form.Label>Title <span className="text-danger">*</span></Form.Label>
//               <Form.Control
//                 type="text"
//                 name="title"
//                 value={formData.title}
//                 onChange={handleInputChange}
//                 placeholder="Enter page title"
//                 required
//               />
//             </Form.Group>
//             <Form.Group className="mb-3">
//               <Form.Label>Route</Form.Label>
//               <Form.Control
//                 type="text"
//                 name="parent_routes"
//                 value={formData.parent_routes}
//                 onChange={handleInputChange}
//                 placeholder="Enter route"
//                 readOnly={!!id}
//               />
//             </Form.Group>
//             <Form.Group className="mb-3">
//               <Form.Label>Author</Form.Label>
//               <Form.Control
//                 type="text"
//                 name="author"
//                 value={formData.author}
//                 onChange={handleInputChange}
//                 placeholder="Enter author"
//               />
//             </Form.Group>
//             <Form.Group className="mb-3">
//               <Form.Label>Content</Form.Label>
//               <div className="routes-editor-wrapper">
//                 <JoditEditor
//                   ref={editor}
//                   value={formData.content}
//                   config={editorConfig}
//                   onBlur={handleContentChange}
//                 />
//               </div>
//             </Form.Group>
//           </Form>
//         </Modal.Body>
//         <Modal.Footer className="routes-modal-footer">
//           <Button variant="secondary" onClick={() => setShowAddModal(false)}>
//             Cancel
//           </Button>
//           <Button variant="primary" onClick={handleCreate}>
//             Create
//           </Button>
//         </Modal.Footer>
//       </Modal>

//       {/* Edit Page Modal */}
//       <Modal 
//         show={showEditModal} 
//         onHide={() => setShowEditModal(false)} 
//         className="routes-modal"
//         dialogClassName="routes-modal-dialog"
//         contentClassName="routes-modal-content"
//       >
//         <Modal.Header closeButton className="routes-modal-header">
//           <Modal.Title>Edit Page</Modal.Title>
//         </Modal.Header>
//         <Modal.Body className="routes-modal-body">
//           <Form className="routes-form">
//             <Form.Group className="mb-3">
//               <Form.Label>Title <span className="text-danger">*</span></Form.Label>
//               <Form.Control
//                 type="text"
//                 name="title"
//                 value={formData.title}
//                 onChange={handleInputChange}
//                 placeholder="Enter page title"
//                 required
//               />
//             </Form.Group>
//             <Form.Group className="mb-3">
//               <Form.Label>Route</Form.Label>
//               <Form.Control
//                 type="text"
//                 name="parent_routes"
//                 value={formData.parent_routes}
//                 onChange={handleInputChange}
//                 placeholder="Enter route"
//                 readOnly={formData.parent_routes}
//               />
//             </Form.Group>
//             <Form.Group className="mb-3">
//               <Form.Label>Author</Form.Label>
//               <Form.Control
//                 type="text"
//                 name="author"
//                 value={formData.author}
//                 onChange={handleInputChange}
//                 placeholder="Enter author"
//               />
//             </Form.Group>
//             <Form.Group className="mb-3">
//               <Form.Label>Content</Form.Label>
//               <div className="routes-editor-wrapper">
//                 <JoditEditor
//                   ref={editor}
//                   value={formData.content}
//                   config={editorConfig}
//                   onBlur={handleContentChange}
//                 />
//               </div>
//             </Form.Group>
//           </Form>
//         </Modal.Body>
//         <Modal.Footer className="routes-modal-footer">
//           <Button variant="secondary" onClick={() => setShowEditModal(false)}>
//             Cancel
//           </Button>
//           <Button variant="primary" onClick={handleUpdate}>
//             Update
//           </Button>
//         </Modal.Footer>
//       </Modal>
//     </div>
//   );
// }

// export default RoutesPage;import React, { useState, useEffect, useRef, useMemo } from 'react';

import { useParams } from 'react-router-dom';
import JoditEditor from 'jodit-react';
import axios from 'axios';
import { Base_Url } from '../config';
import { useEffect, useMemo, useRef, useState } from 'react';
import './PageForm.css';

const PageForm = ({ onSubmit: propOnSubmit, initialData = {} }) => {
  const { id } = useParams();
  const editor = useRef(null);
  const [formData, setFormData] = useState({
    title: initialData.title || '',
    parent_routes: initialData.parent_routes || '',
    route_id: id ? parseInt(id, 10) : null,
    author: initialData.author || '',
  });

  const [content, setContent] = useState(initialData.content || '');
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    const fetchParentRoutes = async () => {
      try {
        if (id) {
          const response = await axios.get(`${Base_Url}/createroutes/${id}`);
          if (response.data && response.data.routes) {
            setFormData(prev => ({
              ...prev,
              parent_routes: response.data.routes,
              route_id: parseInt(id, 10)
            }));
          }
        }
      } catch (err) {
        console.error('Failed to fetch parent routes', err);
      }
    };

    fetchParentRoutes();
  }, [id]);

  const editorConfig = useMemo(() => ({
    readonly: false,
    minHeight: 400,
    editHTMLDocumentMode: true,
    defaultMode: 1,
    enter: 'P',
    useSearch: true,
    buttons: [
      'source', '|', 'bold', 'italic', 'underline', 'strikethrough', 'eraser',
      '|', 'ul', 'ol', 'indent', 'outdent', '|', 'font', 'fontsize',
      'paragraph', 'lineHeight', 'brush', '|', 'superscript', 'subscript',
      'classSpan', '|', 'file', 'image', 'video', '|', 'spellcheck',
      'speechRecognize', '|', 'cut', 'copy', 'paste', 'selectall',
      'copyformat', '|', 'hr', 'table', 'link', 'symbols', '|',
      'ai-commands', 'ai-assistant', '|', 'left', '|', 'undo', 'redo',
      '|', 'find', 'fullsize', 'preview', 'print', 'about'
    ],
    buttonsXS: [
      'ul',
      'ol',
      'paragraph',
      'source'
    ],
    controls: {
      ul: {
        list: {
          default: 'Default',
          circle: 'Circle',
          disc: 'Disc',
          square: 'Square',
        },
      },
    },
    list: {
      indent: true,
      startIndent: 20,
    },
    toolbarAdaptive: false,
    toolbarSticky: true,
    addNewLineOnDBLClick: true,
    toolbarButtonSize: 'middle',
    style: {
      ul: {
        'list-style-type': 'disc',
        'margin-left': '20px',
        'padding-left': '20px'  // Added this
      },
      li: {  // Added li styles
        'list-style': 'inherit',
        'margin-left': '10px'
      }
    },

   
  }), []);


  // const editorConfig = useMemo(() => ({
  //   readonly: false,
  //   minHeight: 400,
  //   editHTMLDocumentMode: true,
  //   defaultMode: 1,
  //   enter: 'P',
  //   useSearch: true,
  //   buttons: [
  //     'source', '|', 'bold', 'italic', 'underline', 'strikethrough', 'eraser',
  //     '|', 'ul', 'ol', 'indent', 'outdent', '|', 'font', 'fontsize',
  //     'paragraph', 'lineHeight', 'brush', '|', 'superscript', 'subscript',
  //     'classSpan', '|', 'file', 'image', 'video', '|', 'spellcheck',
  //     'speechRecognize', '|', 'cut', 'copy', 'paste', 'selectall',
  //     'copyformat', '|', 'hr', 'table', 'link', 'symbols', '|',
  //     'ai-commands', 'ai-assistant', '|', 'left', '|', 'undo', 'redo',
  //     '|', 'find', 'fullsize', 'preview', 'print', 'about'
  //   ],
  //   buttonsXS: [
  //     'ul',
  //     'ol',
  //     'paragraph',
  //     'source'
  //   ],
  //   controls: {
  //     ul: {
  //       list: {
  //         default: 'Default',
  //         circle: 'Circle',
  //         disc: 'Disc',
  //         square: 'Square',
  //       },
  //     },
  //   },
  //   list: {
  //     indent: true,
  //     startIndent: 20,
  //   },
  //   toolbarAdaptive: false,
  //   toolbarSticky: true,
  //   addNewLineOnDBLClick: true,
  //   toolbarButtonSize: 'middle',
  //   style: {
  //     ul: {
  //       'list-style-type': 'disc',
  //       'margin-left': '20px'
  //     }
  //   }
  // }), []); 

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    const submitData = {
      ...formData,
      content,
      route_id: id ? parseInt(id, 10) : (formData.parent_routes ? parseInt(formData.parent_routes, 10) : null),
    };

    try {
      if (propOnSubmit) {
        await propOnSubmit(submitData);
      } else {
        const endpoint = `${Base_Url}/pages`;
        const response = await axios({
          method: "POST",
          url: endpoint,
          data: submitData
        });

        if (response.status === 200 || response.status === 201) {
          alert('Page saved successfully!');
        }
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      alert('Error saving page. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="page-form-container">
      <div className="form-wrapper">
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>
              Title <span className="required">*</span>
            </label>
            <input
              type="text"
              name="title"
              value={formData.title}
              onChange={handleInputChange}
              placeholder="Enter page title"
              required
            />
          </div>

          <div className="form-group">
            <label>Route</label>
            <input
              type="text"
              name="parent_routes"
              value={formData.parent_routes}
              onChange={handleInputChange}
              placeholder="Enter route"
              readOnly={!!id}
            />
          </div>

          <div className="form-group">
            <label>Author</label>
            <input
              type="text"
              name="author"
              value={formData.author}
              onChange={handleInputChange}
              placeholder="Enter author"
            />
          </div>

          <div className="form-group">
            <label>Content</label>
            <div className="editor-container">
              <JoditEditor
                ref={editor}
                value={content}
                config={editorConfig}
                tabIndex={1}
                onBlur={(newContent) => setContent(newContent)}
                onChange={() => {}}
              />
            </div>
          </div>

          <div className="form-actions">
            <button 
              type="submit" 
              className="submit-button"
              disabled={isSubmitting}
            >
              {isSubmitting ? 'Saving...' : 'Submit'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default PageForm;